import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { GetPartnershipFailure, GetPartnershipRequest, GetPartnershipSuccess } from './actions';
import { GetPartnershipService } from './service';

@Injectable()
export class GetPartnershipEffects {
  private readonly actions$ = inject(Actions);
  private readonly getPartnershipService = inject(GetPartnershipService);

  getPartnership$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetPartnershipRequest),
      switchMap(({ parameters }) =>
        this.getPartnershipService.getPartnership(parameters).pipe(
          map(data => GetPartnershipSuccess({ data })),
          catchError(error => of(GetPartnershipFailure({ error })))
        )
      )
    )
  );

}
